import { forwardRef } from 'react'

import {
  StyledButton,
} from './buttonStyle'

const Button = forwardRef(({
  type = 'button',
  secondary,
  fullwidth,
  color,
  ...props
}, ref) => (
  <StyledButton
    type={type}
    ref={ref}
    data-secondary={secondary}
    data-fullwidth={fullwidth}
    data-color={color}
    {...props}
  />
))

export default Button